/**
 * 报价
 */
import React, { useState } from "react"
import { QuotationType } from "../../utils"
import { Declaration } from "./declaration"
import { Transaction } from "./transaction"

export function Quotation(props:{quotecode:string}) {
  const [currentType, setCurrentType] = useState(QuotationType.逐笔申报)

  let currentTypeList = [QuotationType.逐笔申报, QuotationType.逐笔成交]

  return (
    <div className="stock-bj-container">
      <dl className="stock-bj-nav">
        {currentTypeList.map((item: any) => {
          return <dd className={item == currentType ? "active" : ""} onClick={()=>setCurrentType(item)} key={item}>{QuotationType[item]}</dd>
        })}
      </dl>
      {currentType == QuotationType.逐笔申报 ? <Declaration quotecode={props.quotecode}/>:<Transaction quotecode={props.quotecode}/>}
    </div>
  )
}
